// removed by extract-text-webpack-plugin
module.exports = {"warningContainer":"blKPHmdsaN7wdhvUUcWLv","title":"_2GN2TdW9ssXTJPEnlcCXUb","content":"_3VFk4use30gJTPItbvC0ZJ","close":"_2e8b5Ab2ybcdUSfOaebGgs","zhuan_a":"_3hNYTIadR0C0al_oxTcrD2","zhuan":"_1YuxIdw-Qlvtvb7Sc-54Mg"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaymentModal/PaymentModal.scss
 ** module id = 1008
 ** module chunks = 0
 **/